import { render } from "./CertificateStatus.vue?vue&type=template&id=2382f174&scoped=true"
import script from "./CertificateStatus.vue?vue&type=script&lang=js"
export * from "./CertificateStatus.vue?vue&type=script&lang=js"

import "./CertificateStatus.vue?vue&type=style&index=0&id=2382f174&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2382f174"]])

export default __exports__